<template>
  <div class="row">
    <br />
    <br />
    <br />
    <h5
      v-if="error"
      class="red-text center"
    >{{ error === 'permission' ? "You don't have permission" : 'There is a error'}}</h5>
    <div v-else>
      <iframe
        :src="url"
        scrolling="no"
        frameborder="0"
        allowfullscreen
        style="height: 54.6vw; width: 100%; opacity: 1;"
      ></iframe>
      <p>
        <span style="font-size: 20px">{{ getStopwatch }}</span>
        <button @click.once="finish" class="btn indigo" style="float: right">finish</button>
      </p>
    </div>
    <br />
    <br />
    <br />
  </div>
</template>


<script>
export default {
  data() {
    return {
      when: new Date().toLocaleString(),
      stopwatch: {
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      error: "",
      id: "",
      url: ""
    };
  },
  created() {
    this.getLesson();
    this.setStopwatch();
  },
  methods: {
    getLesson() {
      this.$store
        .dispatch("getLesson", {
          level: this.$route.params.level,
          lesson: this.$route.params.lesson
        })
        .then(response => {
          if (response.data.allow === false) this.error = "permission";
          if (response.data.success === false) this.error = "error";
          else {
            this.id = response.data.id;
            this.url = response.data.url;
          }
        });
    },
    setStopwatch() {
      setTimeout(() => {
        this.stopwatch.seconds++;
        if (this.stopwatch.seconds >= 60) {
          this.stopwatch.seconds = 0;
          this.stopwatch.minutes++;
          if (this.stopwatch.minutes >= 60) {
            this.stopwatch.minutes = 0;
            this.stopwatch.hours++;
          }
        }
      }, 1000);
    },
    finish() {
      let name;

      for (let i in this.$store.getters.getInfo) {
        if (this.$store.getters.getInfo[i].level == this.$route.params.level) {
          for (let y in this.$store.getters.getInfo[i].lessons) {
            if (
              this.$store.getters.getInfo[i].lessons[y].lesson ==
              this.$route.params.lesson
            ) {
              name = this.$store.getters.getInfo[i].lessons[y].name;
            }
          }
        }
      }

      this.$store
        .dispatch("finishAndNextLesson", {
          level: this.$route.params.level,
          name,
          lesson: this.$route.params.lesson,
          when: this.when,
          howLong: this.getStopwatch
        })
        .then(response => {
          if (response.data.success) {
            if (
              this.$route.params.level == this.$store.getters.getUser.level &&
              this.$route.params.lesson == this.$store.getters.getUser.lesson
            )
              this.$store.commit("setLesson", +this.$route.params.lesson + 1);

            M.toast({
              html: "Congratulations you can move on to the next lesson",
              classes: "green"
            });
          } else {
            M.toast({
              html: "There is a error",
              classes: "red"
            });
          }

          this.$router.push({ name: "home" });
        });
    }
  },
  computed: {
    getStopwatch() {
      return (
        (this.stopwatch.hours
          ? this.stopwatch.hours > 9
            ? this.stopwatch.hours
            : "0" + this.stopwatch.hours
          : "00") +
        ":" +
        (this.stopwatch.minutes
          ? this.stopwatch.minutes > 9
            ? this.stopwatch.minutes
            : "0" + this.stopwatch.minutes
          : "00") +
        ":" +
        (this.stopwatch.seconds > 9
          ? this.stopwatch.seconds
          : "0" + this.stopwatch.seconds)
      );
    }
  },
  watch: {
    "stopwatch.seconds"() {
      this.setStopwatch();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Lesson.vue